<template>
  <div>
    <b-modal
      id="modal-5"
      class="modal-content"
      title="Scegli la data di ricerca"
      @ok="onRicercaDisponibilita"
      slot="modal-header"
      hide-header-close
      no-close-on-backdrop
      no-close-on-esc
      cancel-title="Chiudi"
      ok-title="Cambia Data"
    >
      <b-container class="bv-example-row">
        <b-row>
          <b-col>
            <b-calendar
							id="calendar-disponibilita"
              block
              v-model="dataSelezionata"
              locale="it"
							selected-variant="primary"
							:date-disabled-fn="dateDisponibilitaDisabilitate"
            ></b-calendar>
          </b-col>
        </b-row>
      </b-container>
    </b-modal>
  </div>
</template>

<script>
import moment from "moment";
export default {
  props: {
    data: Array
  },
  data() {
    return {
      value: "",
      dataSelezionata: null,
    };
  },
  methods: {
		dateDisponibilitaDisabilitate(ymd) {
			const dateDisponibili = [
				'2025-01-07',
				'2025-01-11',
				'2025-01-12',
				'2025-01-14',
				'2025-01-18',
				'2025-01-19',
				'2025-01-21',
				'2025-01-25',
				'2025-01-26',
				'2025-01-28',
			];
			return !(dateDisponibili.includes(ymd));
		},
    onRicercaDisponibilita() {
      let me = this;
      me.dataricerca = moment(me.dataSelezionata).format("DD/MM/YYYY");
      me.$emit("getData", me.dataricerca);
    },
  },
  watch: {
    data: function (){
      this.min = moment(this.data[0].proposta.data, 'DD/MM/YYYY').toDate()
    }
  }
}
</script>

<style>
div#calendar-disponibilita__calendar-grid_ > div.b-calendar-grid-body .row.no-gutters > div > span.disabled {
	background-color: #c82121 !important;
	color: white !important;
	opacity: 1;
}
div#calendar-disponibilita__calendar-grid_ > div.b-calendar-grid-body > .row.no-gutters > div > span {
	background-color: #226900 !important;
	color: white !important;
}
div#calendar-disponibilita__calendar-grid_ > div.b-calendar-grid-body > .row.no-gutters > div > span.active {
	background-color: #00388c !important;
	color: white !important;
}
</style>
